module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-present-1-pc@2x_18245cd5f15430cfbc45ead93dc51772.png";